'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Badge, Button, Dialog, Loader } from '@/shared/components/ui';
import { feriadosService } from '@/features/feriados/services/feriadosService';
import { ACAO_HISTORICO_LABEL, type EventoHistorico } from '@/features/feriados/types/feriadosTypes';
interface HistoricoFeriadosDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
function formatarDataHora(iso: string): string {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return iso;
  return data.toLocaleString('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short'
  });
}
export function HistoricoFeriadosDialog(t0) {
  const $ = _c(17);
  const {
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [eventos, setEventos] = useState(t1);
  const [carregando, setCarregando] = useState(true);
  let t2;
  let t3;
  if ($[1] !== open) {
    t2 = () => {
      if (!open) {
        return;
      }
      setCarregando(true);
      feriadosService.listarHistorico().then(lista => {
        setEventos(lista);
        setCarregando(false);
      });
    };
    t3 = [open];
    $[1] = open;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col"><span className="text-heading-3 font-heading-3 text-default-font">Histórico de alterações</span><span className="text-caption font-caption text-subtext-color">Quem alterou os calendários e feriados, e quando.</span></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== carregando || $[6] !== eventos) {
    t5 = carregando ? <div className="flex h-32 items-center justify-center"><Loader /></div> : eventos.length === 0 ? <span className="text-body font-body text-subtext-color">Nenhuma alteração registrada ainda.</span> : <div className="flex max-h-96 flex-col gap-2 overflow-y-auto">{eventos.map(_temp)}</div>;
    $[5] = carregando;
    $[6] = eventos;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onOpenChange) {
    t6 = <div className="flex justify-end"><Button variant="neutral-secondary" onClick={() => onOpenChange(false)}>Fechar</Button></div>;
    $[8] = onOpenChange;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Dialog.Content className="w-[560px] max-w-[95vw]"><div className="flex w-full flex-col gap-4 p-6">{t4}{t5}{t6}</div></Dialog.Content>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onOpenChange || $[14] !== open || $[15] !== t7) {
    t8 = <Dialog open={open} onOpenChange={onOpenChange}>{t7}</Dialog>;
    $[13] = onOpenChange;
    $[14] = open;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(evento) {
  return <div key={evento.id} className="flex flex-col gap-1 rounded-[8px] border border-solid border-neutral-200 p-3"><div className="flex flex-wrap items-center gap-2"><Badge variant="neutral">{ACAO_HISTORICO_LABEL[evento.acao]}</Badge><Badge variant="brand">{evento.ano}</Badge></div><span className="text-body font-body text-default-font">{evento.descricao}</span><span className="text-caption font-caption text-subtext-color">por {evento.autor} · {formatarDataHora(evento.em)}</span></div>;
}